import { z } from "zod";
export const ZMediaAssetKind = z.enum(["VIDEO", "FILE"]);
export const ZMediaAssetVisibility = z.enum(["PUBLIC", "AUTH"]);
// Optional: known keys (for strongly-typed usage in UI where you want it)
export const ZMediaAssetKeyKnown = z.enum(["REVIT_DEMO", "REVIT_PLUGIN_INSTALLER", "FREETEXT_SEARCH", "CEILING_MODULE", "RFP_MODULE", "EXPLORE_MODULE", "COMPONENT", "COLORFILTER"]);
export const ZMediaAsset = z.object({
    _id: z.any().optional(),
    // ✅ still flexible for future keys
    key: z.string().min(1),
    // ✅ safety switch
    isProtected: z.boolean().nullable().optional(),
    kind: ZMediaAssetKind,
    title: z.string().min(1),
    description: z.string().min(1).nullable().optional(),
    blobPath: z.string().min(1),
    mimeType: z.string().min(1).nullable().optional(),
    tags: z.array(z.string().min(1)).nullable().optional(),
    version: z.string().min(1).nullable().optional(),
    visibility: ZMediaAssetVisibility.nullable().optional(),
    filename: z.string().min(1).nullable().optional(),
    sizeBytes: z.number().int().nonnegative().nullable().optional(),
    uploadedAt: z.union([z.string().datetime(), z.date()]).nullable().optional(),
    updatedAt: z.union([z.string().datetime(), z.date()]).nullable().optional(),
});
export const ZMediaAssetCreate = ZMediaAsset.omit({
    _id: true,
    uploadedAt: true,
    updatedAt: true,
});
export const ZMediaAssetUpdate = ZMediaAssetCreate.partial();
export const MEDIA_ASSET_KEYS = {
    REVIT_DEMO: "REVIT_DEMO",
    REVIT_PLUGIN_INSTALLER: "REVIT_PLUGIN_INSTALLER",
    FREETEXT_SEARCH: "FREETEXT_SEARCH",
    CEILING_MODULE: "CEILING_MODULE",
    RFP_MODULE: "RFP_MODULE",
    EXPLORE_MODULE: "EXPLORE_MODULE",
    COMPONENT: "COMPONENT",
    COLORFILTER: "COLORFILTER",
};
